export const classes = {
  wrapper:
    'relative place-start w-14 h-8 rounded-full transition-colors cursor-pointer',
  activeWrapper: 'bg-green-2',
  inactiveWrapper: 'bg-grey-3 dark:bg-white/[0.2]',
  ball: 'relative size-6 rounded-full bg-white shadow-md transform transition-transform transition-all',
  activeBall: 'left-1/2',
  inactiveBall: 'left-1',
};
